<template>
  <div class="cgsLoginPage">
    <div class="cgsLogo">
      <img :src="require('@/assets/image/iconLogo.png')" width="100px" />
    </div>
    <div class="loginContainer">
      <div class="userNameContent">
        <div class="loginMessLabel hide" :class="userName === '' ? '' : 'show'">
          <span>用户名</span>
        </div>
        <van-field v-model="userName" placeholder="用户名" />
      </div>
      <div class="passwordContent">
        <div class="loginMessLabel hide" :class="password === '' ? '' : 'show'">
          <span>密码</span>
        </div>
        <van-field v-model="password" type="password" placeholder="密码" />
      </div>
      <div class="loginButtonContent">
        <van-button type="info" style="width: 100%" :loading="loginLoading" @click="login">{{ loginButtonMess }}
        </van-button>
      </div>
      <div class="loginErrorContent" v-if="loginError">
        <span>用户名或密码错误</span>
      </div>
      <div class="tool-container">
        <div @click="geoToRegister" class="system1">注册</div>
        <div @click="gosystem" class="system">系统设置</div>
        <div @click="geoToRetrieve" class="system1">忘记密码</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Field,
    Button
  } from "vant";
  import {
    loginByUsername,
    getUserInfo
  } from "@/api/authority";
  import {
    setToken,
    setUserInfo,
    setUserAuthority
  } from "@/util/author";
  import {
    setUserName,
    getUserName
  } from "@/util/appConfigura"
  import qs from "qs";

  export default {
    components: {
      vanField: Field,
      vanButton: Button,
    },
    data() {
      return {
        userName: getUserName(),
        password: "",
        loginButtonMess: "登录",
        loginLoading: false,
        loginError: false,
      };
    },
    methods: {
      async login() {
        this.loginLoading = true;
        let params = {
          Username: this.userName,
          Password: this.password,
          ClientType: 1,
        };
        try {
          let loginResult = await loginByUsername(qs.stringify(params));
          let token = loginResult.Data.Token;
          let userInfo = loginResult.Data;
          setToken(token);
          setUserInfo(userInfo);
          let userResult = await getUserInfo();
          setUserAuthority(userResult.data);
          setUserName(this.userName)
          this.$ws.init();
          this.$router.push({
            path: "/main"
          });
        } catch (e) {
          this.loginError = true;
        } finally {
          this.loginLoading = false;
        }
      },
      gosystem() {
        this.$router.push("/system");
      },
      geoToRegister() {
        this.$router.push("/register");
      },
      geoToRetrieve() {
        this.$router.push("/retrieve");
      }
    },
  };
</script>

<style scoped>
  .cgsLoginPage {
    /* width: 100%;
    height: 100%; */
    /* padding: 30px; */
  }

  .cgsLoginPage .cgsLogo {
    /* width: 100%;
    height: 30%; */
    text-align: center;
    padding: 50px;
  }

  .loginContainer {
    padding: 30px;
  }

  .loginContainer .loginMessLabel {
    color: rgba(0, 0, 0, 0.3);
    padding-left: 10px;
    font-size: 14px;
  }

  .loginContainer .loginErrorContent {
    color: red;
  }

  .loginContainer .hide {
    visibility: hidden;
    opacity: 0;
    transform: translateY(10px);
    transition: 0.5s;
  }

  .loginContainer .show {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }

  .loginContainer .loginButtonContent,
  .loginContainer .loginErrorContent {
    /* margin-top: 10px; */
    padding: 10px 16px;
  }

  .system {
    color: #6ba6c6;
    margin: 20px 0px;
    text-align: center;
  }

  .system1 {
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
    margin: 20px 0px;
    text-align: center;
  }

  .tool-container {
    display: flex;
    justify-content: space-between;
    padding: 0px 16px;
  }
</style>